import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

const BookingsLayoutSwitch = ({ layout, onSwitch }) => {
    return <ButtonGroup>
        {Object.values(BookingLayout).map(x => BookingLayoutConfig[x].enabled && <Button key={x}
            className={`btn-link text-muted ${layout === x ? 'selected' : ''}`}
            style={{ fontSize: 15 }}
            onClick={() => onSwitch(x)}>
            <FontAwesome name={BookingLayoutConfig[x].icon} />
        </Button>)}
    </ButtonGroup>;
};

export const BookingLayout = {
    SINGLE: 'single',
    GRID: 'grid',
    LIST: 'list'
};

const BookingLayoutConfig = {
    [BookingLayout.SINGLE]: { enabled: false, icon: 'square' },
    [BookingLayout.GRID]: { enabled: true, icon: 'th-large' },
    [BookingLayout.LIST]: { enabled: true, icon: 'bars' }
}

export default BookingsLayoutSwitch;